import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';
import { GraphService } from '../../General/graph/graph.service';
import { AbstractNode } from 'graph-interactive/dist/lib/abstract/aNode';
import { AbstractEdge } from 'graph-interactive/dist/lib/abstract/aEdge';
import { GraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { GraphUU } from '../../shared/interactive-graph/simple_graphs/graphUU';
import { NameVertex, InteractionType, Interactable } from 'graph-interactive';

@Component({
  selector: 'app-find-simple-path-fixed-length',
  templateUrl: './find-simple-path-fixed-length.component.html',
  styleUrls: ['./find-simple-path-fixed-length.component.css']
})
export class FindSimplePathFixedLengthComponent extends GraphExerciseComponent {
  private readonly canvasID: string = 'graph-canvas';
  private readonly resetPathID: string = 'resetPathButton';
  private readonly addPathID: string = 'addPathButton';
  private readonly selectID: string = 'selectFoundPaths';

  private foundPathSelect: HTMLSelectElement;
  private foundPaths: [AbstractNode[], AbstractEdge[]][] = [];

  private pathsToFind: number = -1;
  private pathLength: number = -1;



  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService,
    protected messageService: MessageService, graphService: GraphService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
    this.type = 'findSimplePathFixedLength';

  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.graph.setInteractionType(InteractionType.HIGHLIGHT_SIMPLE_PATH);
    this.graph.initSelected(true);

    const resetPathButton = <HTMLButtonElement>document.getElementById(this.resetPathID);
    resetPathButton.addEventListener('click', this.onResetPath, false);

    const addPathButton = <HTMLButtonElement>document.getElementById(this.addPathID);
    addPathButton.addEventListener('click', this.onAddPath, false);

    const selectPath = <HTMLSelectElement>document.getElementById(this.selectID);
    selectPath.addEventListener('keydown', this.pathOnChange, false);
    selectPath.addEventListener('keyup', this.pathOnChange, false);
    selectPath.addEventListener('keypress', this.pathOnChange, false);
    selectPath.addEventListener('change', this.pathOnChange, false);
    selectPath.addEventListener('click', this.pathOnChange, false);

    this.foundPathSelect = selectPath;
  }

  pathOnChange = () => {
    let index = this.foundPathSelect.selectedIndex;
    if (index >= this.foundPaths.length || index < 0) {
      console.log("Invalid index");
      return;
    }
    let path = this.foundPaths[index];
    this.showPath(path);
  }

  onAddPath = () => {
    let nodes = this.graph.getSelectedNodes();
    let edges = this.graph.getSelectedEdges();

    if (nodes.length >= 2) {
      if (nodes[nodes.length - 1] == this.graph.getTargetNode()) {
        let isIncluded = this.pathContainedInCollection([nodes, edges], this.foundPaths);
        if (!isIncluded) {
          if (edges.length < this.pathLength) {
            this.messageService.addAlertWithTimeout(this.get('PathToShort'), 'danger', 5000);
          } else if (edges.length > this.pathLength) {
            this.messageService.addAlertWithTimeout(this.get('PathToLong'), 'danger', 5000);
          } else {
            if(this.hasVisitedMandatory(nodes, this.graph.getMandatoryNodes())){
              this.foundPaths.unshift([nodes, edges]);
              this.messageService.addAlertWithTimeout(this.get('FoundAPath'), 'success', 5000);
              this.foundPathSelect.selectedIndex = this.foundPaths.length - 1;  
            }else{
              this.messageService.addAlertWithTimeout(this.get('NotVisitMandatory'), 'danger', 5000);
            }
          }
        }
        else {
          this.messageService.addAlertWithTimeout(this.get('AlreadyVisitedPath'),
            'danger', 5000);
        }
        this.resetPath();
      } else {
        this.messageService.addAlertWithTimeout("Falsch",
          'danger', 5000);
      }
    } else {
      this.messageService.addAlertWithTimeout("Falsch",
        'danger', 5000);
    }
  }

  showPath = (path: [AbstractNode[], AbstractEdge[]]) => {
    this.graph.highLightPath(path[0], path[1]);
  }

  pathToString = (path: [AbstractNode[], AbstractEdge[]]): String => {
    let res: String = "";
    path[0].forEach(node => {
      if (node instanceof NameVertex) {
        res = res + node.getName() + " ";
      }
    })
    return res;
  }

  onResetPath = () => {
    this.resetPath();
  }

  resetPath() {
    this.graph.resetSelected();
    this.graph.initSelected(true);
    this.graph.forceUpdate();
  }

  initGraph(): InteractiveGraph {
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    const g = new SPFLGraphUU(canvas);
    return g;
  }

  resetState() {
    super.resetState();
    this.graph.resetSelected();
    this.foundPaths = [];
    this.graph.initSelected(true);
    this.graph.forceUpdate();
  }

  setTypeSpecificsFromConfiguration() {
    this.pathsToFind = this.importMinimumPath();
    this.pathLength = this.importPathLength();
  }
  setTypeSpecificsFromState() {

  }
  computeState() {

  }

  checkSolution() {
    let result = this.evaluate();
    if (result[0] >= result[1]) {
      this.messageService.addAlertWithTimeout(this.get('correct'), 'success', 10000);
      this.solved = true;
      this.state.solved = true;
    }
    else {
      this.messageService.addAlertWithTimeout(this.get('MissingPaths'), 'danger', 10000);
    } 
    this.saveState();

  }

  evaluate(): [number, number] {
    return [this.foundPaths.length, this.pathsToFind];
  }


}
//Specific graph for making edges non interactable
class SPFLGraphUU extends GraphUU {
  disableHover(interactabe: Interactable): boolean {
    if (interactabe instanceof AbstractEdge) {
      return true;
    }
    return super.disableHover(interactabe);
  }
}